import { appActionTypes } from '@actions/actionTypes/app';
import { appInitialState } from './initialState/app';
import { AnyAction } from 'redux';

export const appReducer = (state = appInitialState, action: AnyAction) => {
  switch (action.type) {
    case appActionTypes.APP_LOADING: {
      return { ...state, loading: action.payload };
    }
    case appActionTypes.APP_FAILURE: {
      return { ...state, isFailure: action.payload };
    }
    case appActionTypes.SET_LANG: {
      return { ...state, lang: action.payload };
    }
    case appActionTypes.SET_CONTROLLERS_DATA: {
      return { ...state, controllersData: action.payload };
    }
    case appActionTypes.SET_NOTIFICATION: {
      return { ...state, notification: action.payload };
    }
    case appActionTypes.REGISTER_ROUTE: {
      return { ...state, registeredRoute: action.payload };
    }
    case appActionTypes.BACKDROP_LOADING: {
      return { ...state, backdropLoading: action.payload };
    }
    case appActionTypes.BAR_LOADING: {
      return { ...state, barLoading: action.payload };
    }
    default: {
      return state;
    }
  }
};
